import React from 'react';

interface Props {
	size: number;
}

export const TradesIcon: React.FC<Props> = props => (
	<svg
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>trades</title>
		<path d='M4 23.45a1.5 1.5 0 01-1-.4l-1.25-1.13a1.56 1.56 0 01-.12-2.18l11.71-13A4.49 4.49 0 0114 1.91a4.56 4.56 0 015.16-1l.55.22L17.15 4a.72.72 0 00-.15.5.71.71 0 00.2.5l1.11 1a.71.71 0 001 0l2.54-2.82.28.53a4.56 4.56 0 01-.43 5.24A4.5 4.5 0 0116.86 10L5.19 23a1.55 1.55 0 01-1.19.45zM17.16 1.38a3.43 3.43 0 00-2.58 1.09 3.73 3.73 0 00-.36 4.18l.16.33-.3.2-.08.11-11.71 13a.72.72 0 000 1l1.26 1.13a.7.7 0 001-.05l11.71-13a.76.76 0 00.08-.11l.2-.26.33.13a3.72 3.72 0 004.23-.76 3.63 3.63 0 00.55-3.74L19.94 6.5a1.55 1.55 0 01-2.18.11l-1.11-1a1.55 1.55 0 01-.12-2.18l1.72-1.9a4.2 4.2 0 00-1.09-.15z' />
	</svg>
);
